var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoansHeaderIconPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75049 6.41634H19.2505",
    stroke: "#4C2D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77295 10.0833H6.41711",
    stroke: "#4C2D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33382 15.5833H5.50049C3.98157 15.5833 2.75049 14.3522 2.75049 12.8333V5.5C2.75049 3.98108 3.98157 2.75 5.50049 2.75H16.5005C18.0194 2.75 19.2505 3.98108 19.2505 5.5V9.16667",
    stroke: "#4C2D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6255 15.125L19.2505 13.75L17.8755 15.125",
    stroke: "#4C2D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5421 16.042L11.9171 17.417L13.2921 16.042",
    stroke: "#4C2D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9171 17.417V13.7503C11.9171 12.7374 12.7375 11.917 13.7504 11.917H16.5004",
    stroke: "#4C2D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2505 13.75V17.4167C19.2505 18.425 18.4255 19.25 17.4172 19.25H14.6772",
    stroke: "#4C2D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoansHeaderIconPurple);
export default __webpack_public_path__ + "static/media/loans-header-icon-purple.a22eb585a6ccb48c27d5b271f23108d8.svg";
export { ForwardRef as ReactComponent };